import { useMemo, type ReactElement, type ReactNode } from 'react';

import { UnsavedChangesContext } from './UnsavedChangesContext';
import { useUnsavedChangesContextValue } from './useUnsavedChangesContextValue';

interface UnsavedChangesModalProviderProps {
  children: ReactNode;
}

/**
 * Supplies unsaved-changes context inside antd Modal portals (rendered outside the main React tree).
 * Does not register route blockers — the root `UnsavedChangesProvider` handles navigation.
 */
export function UnsavedChangesModalProvider({
  children,
}: UnsavedChangesModalProviderProps): ReactElement {
  const contextValue = useUnsavedChangesContextValue();

  const memoizedValue = useMemo(() => contextValue, [contextValue]);

  return (
    <UnsavedChangesContext.Provider value={memoizedValue}>
      {children}
    </UnsavedChangesContext.Provider>
  );
}
